import React, { useState } from 'react';
import { RecoilRoot } from 'recoil'
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Cookies } from 'react-cookie'

import './App.scss';
import './styles/dashboard.css';
import routes from "./router/route";
import { Header } from "./components/layout";
import { Authen } from "./components/Authen"


import BeaconeMap from "./components/BeaconeMap";
import BeaconLacation from "./components/BeaconLacation";
import BeaconLacationDetail from "./components/BeaconLacationDetail";
import BeaconDetail from './components/BeaconDetail';
import { Footer } from './components/layout';


const cookies = new Cookies()

// const PrvateRoute = ({ component: C, props: cProps, ...rest }) => (
//   <Route {...rest} render={props => ((cookies.get('user') === undefined || cookies.get('user') === null) ? (window.location = process.env.REACT_APP_AUTH_URL) : (<C {...props} {...cProps} />))} /> 
// )


function App() {
  const [sideOpen, setSideOpen] = useState(false);
  const d = new Date();
  const startDate = new Date();
  // const [endDate, setEndDate] = useState(new Date());
  const [dateRange, setDateRange] = useState([new Date(startDate.setDate(d.getDate() - 6)), d]);
  // console.log(dateRange)
  return (
    <RecoilRoot>
      <Router>
        <div className="mb-5">
        <Switch>
          {(cookies.get('user') === undefined || cookies.get('user') === null) ? (window.location = process.env.REACT_APP_AUTH_URL) : ''

          }
          {routes.map(({ path, name, Component }, key) => (

            <Route
              exact
              path={path}
              key={key}
              render={props => {
                const _ = routes
                  // Get all routes that contain the current one.
                  .filter(({ path }) => props.match.path.includes(path))
                  // Swap out any dynamic routes with their param values.
                  // E.g. "/pizza/:pizzaId" will become "/pizza/1"
                  .map(({ path, ...rest }) => ({
                    path: Object.keys(props.match.params).length
                      ? Object.keys(props.match.params).reduce(
                        (path, param) =>
                          path.replace(`:${param}`, props.match.params[param]),
                        path
                      )
                      : path,
                    ...rest
                  }));

                return (
                  <>
                    <div className="app-header">
                      <Header setSideOpen={setSideOpen} sideOpen={sideOpen} />

                      {/* <Sidebar sideOpen={sideOpen} setSideOpen={setSideOpen} path={routes} /> */}

                    </div>
                    <div className="app-wrapper">
                      {/* <Breadcrumbs crumbs={crumbs} DateNow={dateRange} setDateRange={setDateRange}/> */}
                      {/* <div className="app-content p-md-1 p-lg-3 pt-2"> */}
                      <div className="app-content">
                        <Component {...props} DateNow={dateRange} />
                      </div>
                    </div>
                  </>
                );
              }}
            />
          ))}
          <Route
            exact
            path='/'
            component={BeaconeMap}
          />
          <Route
            path='/beacons-location'
            component={BeaconLacation}
          />
          <Route
            path='/beacons-location-detail/:id'
            component={BeaconLacationDetail}
          />
          <Route path='/beacons-detail/:id' component={BeaconDetail} />
          <Route exact path='/authen' component={Authen} />
        </Switch>
        </div>
      </Router>
      <Footer />
    </RecoilRoot>
  );
}

export default App;
